export default "__VITE_ASSET__CUkADWvf__"